export interface ItemPlanta {
    id: string;       // Identificador único del elemento
    name: string;     // Nombre del elemento
    name_front: string;     // Nombre  que se muestra
    ubicacion: string;     // Nombre del elemento
    orden: string;    // Orden de Aoaricion en la lista de consulas
}

export interface ItemFrigorifico {
    id: string;       // Identificador único del elemento
    name: string;     // Nombre del elemento
    name_front: string;     // Nombre  que se muestra
    ubicacion: string;     // Nombre del elemento
    orden: string;    // Orden de Aoaricion en la lista de consulas
    planta: ItemPlanta; // Planta
}


export interface ItemCamara {
    id: string;       // Identificador único del elemento
    name: string;     // Nombre del elemento
    tipo_camara: CamaraType;
    orden: string;    // Orden de Aoaricion en la lista de consulas
    planta: ItemPlanta; // Planta
    frigorifico: ItemFrigorifico; // Frigorifico
}

export interface ItemSensor {
    id: string;       // Identificador único del elemento
    name_db: string;     // Nombre del elemento
    name_front: string;     // Nombre del elemento
    descripcion: string;
    tipo_dato: SensorDato;
    tipo_sensor: SensorType;
    color_front: SensorColor;
    max_grafico: number;
    min_grafico: number;
    orden: string;    // Orden de Aparicion en la lista de consulas
    historico: boolean; //Define si es historico el sensor para que se almacenem los valores
                        //y tenga un grafico historico
    value: string; //Valor que se va actualizando con los envios de datos de los scadas
    fecha_hora_value: Date; //Fecha y Hora que se va actualizando enviado por el scada 
    color_fondo: string; //Color de fondo que se va actualizando con el scada 
    color_fuente: string; //Color de fuente que se va actualizando con el scada
    planta: ItemPlanta; // Planta
    frigorifico: ItemFrigorifico; // Frigorifico
    camara: ItemCamara; // Cámara
}


export enum SensorDato{
    BOOLEAN = "BOOLEAN",
    INT16 = "INT16",
    INT32 = "INT32",
    FECHA_HORA = "FECHA_HORA",
    FECHA = "FECHA",
    SEMANA_HORA = "SEMANA_HORA",
    DIA_HORA = "DIA_HORA",
    HORA = "HORA",
    REAL = "REAL",
    REAL_DIV_10 = "REAL_DIV_10",
    STRING = "STRING"
}

export enum SensorType{
    TEMPERATURA = "TEMPERATURA", //Valor de Temepratura en ºC -> REAL_DIV_10
    SET_POINT_TEMPERATURA = "SET_POINT_TEMPERATURA", //Valor de Set Point de Temepratura en ºC -> REAL_DIV_10
    HUMEDAD = "HUMEDAD", //Valor de Humedad en % -> REAL_DIV_10
    PRESION = "PRESION", //Valor de Presion en Bar -> REAL_DIV_10
    SET_POINT_PRESION = "SET_POINT_PRESION", //Valor de Set Point de Presion en Bar -> REAL_DIV_10
    CAPACIDAD = "CAPACIDAD", //Valor de Capacidad en % -> INT16
    POTENCIA = "POTENCIA", //Valor de Potencia en KW -> INT32
    SET_POTENCIA = "SET_POTENCIA", //Valor de Set Point de Potencia en KW -> INT32
    TENSION = "TENSION", //Valor de Tension en V -> INT32
    CORRIENTE = "CORRIENTE", //Valor de Corriente en A -> INT32
    COSENO_PHI = "COSENO_PHI", //Valor de Cosenso Phi -> REAL
    VELOCIDAD_HZ = "VELOCIDAD_HZ", //Valor de Velocidad en Hz -> REAL_DIV_10
    VELOCIDAD_100 = "VELOCIDAD_100", //Valor de Velocidad en % -> INT16
    APERTURA_VALVULA = "APERTURA_VALVULA", //Valor de Apertura Valvula Capacidad en % -> INT16
    MENSAJE_FUNCIONAMIENTO = "MENSAJE_FUNCIONAMIENTO", //Mensaje general de funcionamiento de Camaras, Sala de Maquinas, etc. -> STRING
    ESTADO_VENTILADORES = "ESTADO_VENTILADORES", // ON-OFF Ventiladores -> BOOLEAN 
    ESTADO_SOL_ASPIRACION = "ESTADO_SOL_ASPIRACION", // ON-OFF Sol. de Aspiracion -> BOOLEAN 
    ESTADO_SOL_LIQUIDO = "ESTADO_SOL_LIQUIDO", // ON-OFF Sol. de Liquido -> BOOLEAN 
    ESTADO_SOL_DESHIELO = "ESTADO_SOL_DESHIELO", // ON-OFF Sol. de Deshielo -> BOOLEAN 
    ESTADO_VALVULA = "ESTADO_VALVULA", // ON-OFF Vavula -> BOOLEAN 
    ESTADO_COMPRESOR = "ESTADO_COMPRESOR", // ON-OFF Motor Compresor -> BOOLEAN 
    ESTADO_TORNILLO = "ESTADO_TORNILLO", // ON-OFF Motor Compresor Tornillo-> BOOLEAN 
    ESTADO_BOMBA = "ESTADO_BOMBA", // ON-OFF Motor Bomba  -> BOOLEAN 
}

export enum SensorColor{
    RED = "RED",
    BLUE = "BLUE",
    GREEN = "GREEN",
    BLACK = "BLACK",
    ORANGE = "ORANGE",
    YELLOW = "YELLOW",
    PURPLE = "PURPLE",
    PINK = "PINK",
    BROWN = "BROWN",
    WHITE = "WHITE",
}


export enum CamaraType{
    CAMARA_AMONIACO = "CAMARA_AMONIACO", //Representa una Camara de Amoniaco con Ventiladores, Sol. de Aspiracion y Liquido, Sol, Deshielo, etc,
    CAMARA_GLICOL = "CAMARA_GLICOL", //Representa una Camara de Glicol con Ventiladores, Bomba GLicol, Valvula Glicol, Sol, Deshielo, etc,
    COMPRESOR = "COMPRESOR", //Representa un Compresor con Estado Funcionamiento, Capacidad, etc
    SALA_MAQUINAS = "SALA_MAQUINAS", //Representa los sensores de presion , Estados general de funcionamiento, etc.
    MEDIDAS_ELECTRICAS = "MEDIDAS ELECTRICAS", //Representa los valores de medidas electricas: potencia, tension, corriente, etc.
}

/*export enum BoolDato{
    TRUE = 1,
    FALSE = 0
}*/
